import React, { Component } from 'react';

class SoundEffectBarebone extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='sound-effect sound-effect--barebone'>
        <div className='sound-effect__play-icon' onClick={this.handleClick}>
          <i className='fa fa-play' />
        </div>
        <div className="sound-effect__title-wrapper">
          <span className="sound-effect__title">
            <span className="sound-effect__id">{Math.random() < 0.5 ? 100 : 10000}</span>
            <span className="sound-effect__title-value">{Math.random() < 0.5 ? '_________' : '____________________'}</span>
          </span>
          <span className="sound-effect__composer">by <a className="sound-effect__composer-name">{Math.random() < 0.5 ? '_________' : '____________________'}</a></span>
        </div>
        <div className="sound-effect__length hide-lg-down">
          <span className='sound-effect__length-value'>{Math.random() < 0.5 ? '______' : '_________'}</span>
        </div>
        <a href='#' className='sound-effect__favorite-link'><span><i className="fa fa-heart-o"></i></span><span className='sound-effect__favorite-label'>{this.props.locale === 'de' ? 'merken' : 'remember'}</span></a>
        <div className="sound-effect__cart-link">
          <a className="sound-effect__action-button-add-to-cart" href="#"><span className='sound-effect__cart-link-icon'><i className="sound-effect__cart-link-icon-add fa fa-plus"></i><i className="fa fa-shopping-cart sound-effect__cart-link-icon-cart"></i></span></a>
        </div>
      </div>
    )
  }
};

export default SoundEffectBarebone;
